var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"drag-icon"},[_c('i',{staticClass:"fa",class:[("fa-ellipsis-" + (_vm.props.direction))]}),_c('i',{staticClass:"fa",class:[("fa-ellipsis-" + (_vm.props.direction))]})])}
var staticRenderFns = []

export { render, staticRenderFns }